import React from 'react';
import Markup from './markup/Markup';
import './css/plugins.css';
import './css/style.css';
import './css/templete.css';
import './css/skin/skin-1.css'; 

import './plugins/bootstrap-select/bootstrap-select.min.css';
import './plugins/slick/slick.min.css';
import 'react-modal-video/css/modal-video.min.css';


function App() {
  return (
				
		<div className="App">
			<Markup />
		</div>	
  );
}

export default App;
